// extracted by mini-css-extract-plugin
export var filterButton = "_pp-1";
export var filtersContainer = "_pp-0";